import React, { useEffect, useState } from "react";
import loaderSvg from "../../../assets/images/logos/loader.svg";
import "./Loader.css";

const LOADER_DURATION_MS = 1250;

const Loader = ({ onFinish }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, LOADER_DURATION_MS - 200);

    const finishTimer = setTimeout(() => {
      onFinish?.();
    }, LOADER_DURATION_MS);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div className={`loader ${isExiting ? "loader--exit" : ""}`}>
      <div className="loader__content">
        <img
          src={loaderSvg}
          alt="Federal Commission of Integrity"
          className="loader__logo"
        />
      </div>
    </div>
  );
};

export default Loader;
